
import tripLogo from "../../assets/img/tripLogo.png"
import Img1 from "../../assets/img/q.png";
import Img2 from "../../assets/img/v.jpg";
import Img3 from "../../assets/img/a.jpg"
import { Link } from "react-router-dom";
const TripFirstStep = () =>{

    return(
        <div
        className="h-screen flex flex-col justify-center items-center bg-gray-100 tripBackgroud">
        <div className="flex items-center mb-2">
          <img src={tripLogo} alt="Trip Logo" className="w-[50px] ml-2" />
          <span className="font-Beiruti text-[#265069] text-[20px]">
            چت بات گردشگری
          </span>
          </div>
        <div
            className="bg-[#fdfdfd] w-[75%] lg:w-[95%]  rounded-xl p-6 sm:p-3 shadow-lg flex flex-col items-start relative">

            
            <p
                className="font-Beiruti text-[#f8b323] text-[30px] sm:text-[20px] text-center block mx-auto font-semibold">
                به دنیای سفر خوش اومدی !
            </p>
            <p className="text-[#000] font-IRANYekanBold text-[14px] w-[90%] text-center mx-auto mt-4 mb-2">
            برای اینکه سفر بعدیت دقیقاً همون چیزی باشه که دوست داری، ما چند تا ابزار هوشمند و راحت برات آماده کردیم! با یه پرسشنامه ساده می‌تونی سلیقه و شرایطت رو مشخص کنی تا ما بهترین مقصد رو بهت پیشنهاد بدیم. اگه حوصله تایپ نداری، فقط کافیه ویس بدی، ما از صدات اطلاعات لازم رو درمیاریم و بهت هتل و پرواز و ... پیشنهاد میدیم. حتی اگه بخوای سریع‌تر پیش بری، می‌تونی مدارک شناسایی‌ت رو آپلود کنی تا اطلاعات لازم رو خودمون از روش استخراج کنیم. راحت، سریع و دقیق!            </p>
           <div className="grid grid-cols-3 gap-5 w-full px-5 mt-5">
           <div className="col-span-1 relative md:col-span-3">
  <Link to="/tripQuestion" className="group block relative overflow-hidden rounded-lg">
    <div className="transition-transform duration-300 ease-in-out group-hover:scale-105">
      <img
        src={Img1}
        alt=""
        className="h-[170px] w-full rounded-lg object-cover"
      />


      <div className="absolute inset-0 rounded-lg bg-gradient-to-t from-[#000000cc] via-[#00000033] to-transparent transition-opacity duration-300 pointer-events-none" />
    </div>


    <span className="text-white absolute top-[80%] right-[15px] font-IRANYekanExtra z-10 sm:text-[12px]">
      مقصد رویایی خودتو پیدا کن!
    </span>
  </Link>
</div>


              
<div className="col-span-1 relative md:col-span-3">
  <Link to="/tripVoice" className="group block relative overflow-hidden rounded-lg">
    <div className="transition-transform duration-300 ease-in-out group-hover:scale-105">
      <img
        src={Img2}
        alt=""
        className="h-[170px] w-full rounded-lg object-cover"
      />
      <div className="absolute inset-0 rounded-lg bg-gradient-to-t from-[#000000cc] via-[#00000033] to-transparent transition-opacity duration-300 pointer-events-none" />
    </div>
    <span className="text-white absolute top-[80%] right-[15px] font-IRANYekanExtra z-10 sm:text-[12px]">
      با ویس بلیت و هتلتو پیدا کن!
    </span>
  </Link>
</div>


<div className="col-span-1 relative md:col-span-3">
  <Link to="/tripForm" className="group block relative overflow-hidden rounded-lg">
    <div className="transition-transform duration-300 ease-in-out group-hover:scale-105">
      <img
        src={Img3}
        alt=""
        className="h-[170px] w-full rounded-lg object-cover"
      />
      <div className="absolute inset-0 rounded-lg bg-gradient-to-t from-[#000000cc] via-[#00000033] to-transparent transition-opacity duration-300 pointer-events-none" />
    </div>
    <span className="text-white absolute top-[80%] right-[15px] font-IRANYekanExtra z-10 sm:text-[12px]">
      با آپلود مدارک، فرمتو تکمیل کن!
    </span>
  </Link>
</div>

           </div>
        </div>

    </div>
    )
}

export default TripFirstStep;